import momentUtils from '@/services/moment-utils';
import { env } from '@/services/dev';
import utils from '@/services/tools';
import http from '@/services/http';

// 出签推送消息小程序跳转链接  页面跳转类型，1：订单详情页 2：订单列表-我的列表-已完成 3：订单列表-我的订单-办理中
const signReminderWxaUrlMap = {
  1: '/pages/order/order-detail/order-detail.html',
  2: '/pages/order/order/order.html',
  3: '/pages/order/order/order.html',
};

export default {
  // 出签提醒
  getMessageSignReminderList(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/applicant_sign_reminder_query`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  // 获取群发消息的外部联系人id列表
  getShareSignReminderIdList(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/applicant_sign_reminder_send_all`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  // 更改出签状态
  getMessageSignReminderStatus(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/applicant_sign_reminder_status`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  // 生成群发批次
  getMessageSignReminderBatchId(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/applicant_sign_reminder_cache_save`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  // 检查单发时候是否存在有效
  checkApplicantSignReminder(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/applicant_sign_reminder_check`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },

  // 获取微信小程序跳转参数
  getSignReminderToWxaParams(record) {
    if (!record) return {};
    const wxaUrl = this._getSignReminderToWxaURL(record);
    const message = this._getSignReminderToWxaMsg(record);
    return {
      wxaUrl,
      message,
    };
  },

  // 出签消息提醒跳转
  _getSignReminderToWxaURL(record) {
    let wxaUrl = signReminderWxaUrlMap[record.page_type];
    // 页面跳转类型，1：订单详情页 2：订单列表-我的列表-已完成 3：订单列表-我的订单-办理中
    if (record.page_type === 1) {
      wxaUrl += `?user_order_id=${record.order_id}&source=qw`;
    } else if (record.page_type === 2) {
      wxaUrl += '?default_tab=3&source=qw';
    } else if (record.page_type === 3) {
      wxaUrl += '?default_tab=2&source=qw';
    }
    return wxaUrl;
  },

  // 获取发送的消息名称
  _getSignReminderToWxaMsg(record) {
    if (!record || !record.finish_desc) return '';
    const strList = record.finish_desc.split(' ');
    if (strList.length > 1) {
      // 去除前置，然后拼接
      strList.splice(0, 1);
      return `您${strList.join('')}`;
    }
    return record;
  },
  // 群发api
  _shareToExternalContact(idList, wxaUrl) {
    return new Promise((resolve, reject) => {
      ww.shareToExternalContact({
        externalUserIds: idList || [],
        text: {
          content:
            '您最近申请的签证的已经出签，请尽快打开小程序核对出签信息，以免影响出行。',
        },
        attachments: [
          {
            msgtype: 'miniprogram', // 消息类型，必填
            miniprogram: {
              appid: 'wxf0b01253d8a305ca', // 小程序的appid
              title: '您有出签信息需要核对', // 小程序消息的title
              imgUrl:
                'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdvh5/wwx/share-sign-reminder.png', // 小程序消息的封面图。必须带http或者https协议头
              page: wxaUrl, // 小程序消息打开后的路径，注意要以.html作为后缀，否则在微信端打开会提示找不到页面
            },
          },
        ],
        success() {
          resolve();
        },
        fail() {
          const err = { msg: '群发失败' };
          console.error('企微接口群发失败');
          reject(err);
        },
      });
    });
  },

  // 单发api
  _sendChatMessage(msg, wxaUrl) {
    return new Promise(async (resolve, reject) => {
      try {
        // 1. 先发送文本消息
        await new Promise((textResolve, textReject) => {
          ww.sendChatMessage({
            msgtype: 'text', // 消息类型为文本
            enterChat: false, // 不进入会话（等小程序消息发送后再进入）
            text: {
              content:
                '您最近申请的签证已经出签，请尽快打开小程序核对出签信息，以免影响出行。',
            },
            success() {
              textResolve();
            },
            fail() {
              textReject(new Error('文本消息发送失败'));
            },
          });
        });

        // 2. 再发送小程序消息
        await new Promise((miniResolve, miniReject) => {
          ww.sendChatMessage({
            msgtype: 'miniprogram', // 消息类型为小程序
            enterChat: true, // 发送完成后进入会话
            miniprogram: {
              appid: 'wxf0b01253d8a305ca', // 小程序的appid
              title: msg, // 小程序消息的title
              imgUrl:
                'https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdvh5/wwx/share-sign-reminder.png', // 封面图
              page: wxaUrl, // 小程序路径（带 .html 后缀）
            },
            success() {
              miniResolve();
            },
            fail() {
              miniReject(new Error('小程序消息发送失败'));
            },
          });
        });
        resolve(); // 全部发送成功
      } catch (error) {
        reject(error); // 任意一步失败都会抛出错误
      }
    });
  },

  // 判断是否今天能够调用群发Api
  isCanShareAll() {
    const currentDay = momentUtils.format('YYYY-MM-DD');
    const currentUserId =
      localStorage.getItem('user_id') || localStorage.getItem('chat_id');
    const obj = localStorage.getItem('sign_reminder_batch_time')
      ? JSON.parse(localStorage.getItem('sign_reminder_batch_time'))
      : {};

    return !obj || obj[currentUserId] !== currentDay;
  },
  // 更新群发api有效时间
  updateShareAll() {
    const currentDay = momentUtils.format('YYYY-MM-DD');
    const currentUserId =
      localStorage.getItem('user_id') || localStorage.getItem('chat_id');
    const obj = localStorage.getItem('sign_reminder_batch_time')
      ? JSON.parse(localStorage.getItem('sign_reminder_batch_time'))
      : {};
    obj[currentUserId] = currentDay;
    localStorage.setItem('sign_reminder_batch_time', JSON.stringify(obj));
  },
};
